import { IataContinent } from "../../iata/objects/iataContinent";
import { IataCountry } from "../../iata/objects/iataCountry";
import { Organisation } from "../../organisation/objects/organisation";
import { Author } from "../../user/objects/author";

export enum MarketType {
    'ALL' = 'ALL',
    'CLIENT' = 'CLIENT',
}
export interface MarketBaseLocalized {
    title: string;
    locale: number
}
export interface MarketBase {
    id?: number;
    name: string;
    type: MarketType;
    localization?: MarketBaseLocalized[];
    name_localized: Record<number,string>;
    is_active: boolean;

    creator?: Author | null;
    last_author?: Author | null;
    created_date?: Date;
    modified_date?: Date;
}
export interface MarketAll {
    type: MarketType.ALL;
    details: {
        continents: IataContinent[] ;
        countries: IataCountry[];
        clients: Organisation[];
    }
}

export interface MarketByClient {
    type: MarketType.CLIENT;
    details: {
        continents: IataContinent[] ;
        countries: IataCountry[];
        clients: Organisation[];
    }
}

export type MarketView = MarketBase & (MarketAll | MarketByClient);

export type MarketViewKeyErrors = `${keyof MarketView}_error`;
export type MarketViewErrors = {
    [K in MarketViewKeyErrors]?: string
}


export type MarketViewFormType = MarketView & MarketViewErrors;